export default __webpack_public_path__ + "assets/models/72388c465fd52bf2d3b225b68b135b29.glb";